export default __webpack_public_path__ + "static/media/Logo_PURE-HEALTH-transperent.ddb44717.png";